export default {
    badges: {
        countryId: 'Country',
        cityId: 'City',
        filter: 'Search term',
        fromPrice: 'Price from',
        toPrice: 'Price to',
        serviceId: 'Sub category',
        serviceGroupId: 'Category',
        orderBy: 'Order by',
        sort: {
            createdAt_ASC: 'Date ascending',
            createdAt_DESC: 'Date descending',
            distance_ASC: 'Distance - near by',
            priceRSD_ASC: 'Price ascending',
            priceRSD_DESC: 'Price descending',
            averageRating_ASC: 'Rating ascending',
            averageRating_DESC: 'Rating descending',
        },
    },
}
